import {
    billContract,
    BillExportQueryParams,
} from "@common/contracts/bill.contract";
import { getBackendAPIClient } from "./backendAPIClient";
import { XLSX_MIME } from "./fileDownload";

const billBlobClient = getBackendAPIClient(billContract, "blob", {
    jsonQuery: true,
});

export async function getBillsXlsx({
    workspaceId,
    filters,
    sort,
    groupBy,
    columns,
}: {
    workspaceId: string;
} & BillExportQueryParams) {
    return await billBlobClient.exportBillsXlsx({
        params: { workspaceId },
        query: {
            filters,
            sort,
            groupBy,
            columns,
        },
        extraHeaders: { Accept: XLSX_MIME },
    });
}
